import React, { useEffect, useState, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//PRINT
import { useReactToPrint } from 'react-to-print';

//ICONS
import { BsPrinterFill } from 'react-icons/bs';

//APIS
import { seminerGetbyId } from '../../../apis/seminer';

const SeminerPrint = () => {
  let { code } = useParams();
  const { state } = useLocation();

  //REFS
  const componentRef = useRef();

  //STATES
  const [seminerLIST, setSeminerLIST] = useState([]);

  //HANDLE FUNCTIONS

  const tarihGetir = () => {
    var simdikiZaman = new Date();

    var gun = simdikiZaman.getDate();
    var ay = simdikiZaman.getMonth() + 1;
    var yil = simdikiZaman.getFullYear();

    return gun + '/' + ay + '/' + yil;
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle:
      seminerLIST?.ogrenci?.ogrenciNo +
      ' - ' +
      seminerLIST?.ogrenci?.ogrenciAdiSoyadi,
  });

  //APIS FUNCTIONS
  const getSeminerLIST = async () => {
    let result = await seminerGetbyId(code);
    console.log(result);
    if (result.status === 200) {
      setSeminerLIST(result.data);
    }
  };

  useEffect(() => {
    if (state?.durum === 'ok') {
      toast.success('Seminer formunuz başarıyla oluşturulmuştur', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    getSeminerLIST();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <ToastContainer />
      <main className="text-slate-500 text-sm transition-all">
        <div className="py-5">
          <div className="w-full px-4 sm:px-6 md:px-8">
            <div className="container mx-auto">
              <h1 className="page-title leading-6  text-lg mb-6 text-slate-500">
                Başvuru Görüntüleme
              </h1>
            </div>
            <div className="container mx-auto space-y-4">
              <div className="kapsama relative w-full flex flex-col lg:flex-row gap-4">
                <div className="w-full">
                  <div className="bg-white rounded-lg p-4 min-h-0 pb-28">
                    <div className="">
                      {seminerLIST?.seminerDurum !== 1 ? (
                        <button
                          className=" mr-6 mt-4 inline-flex items-center gap-x-2 float-right"
                          onClick={handlePrint}
                        >
                          <BsPrinterFill className="text-teal-600 text-2xl" />{' '}
                          Yazdır
                        </button>
                      ) : null}
                      <div
                        ref={componentRef}
                        className="w-full rounded-sm px-12 pt-10  "
                      >
                        <table className="w-full">
                          <tbody>
                            <tr>
                              <td
                                className="w-1/3"
                                style={{
                                  backgroundImage: 'url(/images/odu.png)',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: '80px 80px',
                                  backgroundPosition: '0 14px',
                                }}
                              >
                                <div className="flex flex-col justify-center text-center font-semibold">
                                  <div>T.C.</div>
                                  <div>ORDU ÜNİVERSİTESİ</div>
                                  <div>{seminerLIST?.enstituName}</div>
                                  <div className="mt-4">
                                    SEMİNER BİLDİRİM FORMU
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <table className="w-full mt-4 border-2 border-slate-900 table-auto">
                          <tbody>
                            <tr className="border-b-2 border-b-slate-900">
                              <td
                                className="p-1 font-semibold text-center border-r border-slate-900"
                                colSpan="2"
                              >
                                PROGRAM
                              </td>
                              <td className="p-1 font-semibold">
                                {seminerLIST?.seminerProgrami}
                              </td>
                            </tr>
                            <tr className="relative">
                              <td
                                className="py-6 px-2 bg-slate-200 border-r-2 border-r-slate-900 border-b-2 border-slate-900"
                                style={{ writingMode: 'tb-rl' }}
                                rowSpan="5"
                              >
                                <div className="text-center rotate-180 font-semibold text-xs">
                                  ÖĞRENCİNİN
                                </div>
                              </td>
                              <td className="p-1 border border-slate-900">
                                Adı Soyadı
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.ogrenci?.ogrenciAdiSoyadi}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Öğrenci Numarası
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.ogrenci?.ogrenciNo}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Anabilim/Anasanat Dalı
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.anabilimName}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Bilim/Sanat Dalı
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.bilimsanatdaliName}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Cep Telefonu
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.ogrenci?.ogrenciCepNo}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="py-6 px-2 bg-slate-200 border-r-2 border-r-slate-900 border-b-2 border-slate-900"
                                style={{ writingMode: 'tb-rl' }}
                                rowSpan="2"
                              >
                                <div className="text-center rotate-180 font-semibold text-xs">
                                  DANIŞMAN
                                </div>
                              </td>
                              <td className="p-1 border border-slate-900">
                                Unvanı, Adı Soyadı
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.danisman?.danismanUnvan}{' '}
                                {seminerLIST?.danisman?.danismanAdSoyad}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Cep Telefon Numarası
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.danisman?.danismanCepNo}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="py-6 px-2 bg-slate-200 border-r-2 border-r-slate-900 border-b-2 border-slate-900"
                                style={{ writingMode: 'tb-rl' }}
                                rowSpan="5"
                              >
                                <div className="text-center rotate-180 font-semibold text-xs">
                                  SEMİNERİN
                                </div>
                              </td>
                              <td className="p-1 border border-slate-900">
                                Sunum Şekli
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.seminerTuru}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Konusu
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.seminerKonusu}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Sunum Tarihi
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.seminerTarihi}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Sunum Saati
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.seminerSaati}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-1 border border-slate-900">
                                Sunum Yapılacak Yer
                              </td>
                              <td
                                className="p-1 border border-slate-900"
                                colSpan="2"
                              >
                                {seminerLIST?.seminerYeri}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table className="w-full mt-10">
                          <thead>
                            <tr>
                              <td className="text-right space-y-1 pr-4">
                                <div className="font-semibold">
                                  {tarihGetir()}
                                </div>
                                <div className="font-semibold">Danışman</div>
                                <div className="font-semibold">
                                  {seminerLIST?.danisman?.danismanUnvan}{' '}
                                  {seminerLIST?.danisman?.danismanAdSoyad}
                                </div>
                              </td>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default SeminerPrint;
